import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack,
  FDAccordionGroup,
  FDEmptyState,
  FDSecondaryActionIconButton,
  FDSimpleAccordion,
  FDTitleText,
} from '@facet-wealth/design';
import RichTextDisplay from 'Components/UI/RichTextDisplay';

/** AccordionStepper is a component that expects a resource of the following shape:
  {
    title
    sections: [
      {
        title
        details
      }
      ...
    ]
  }
*/
const AccordionStepper = ({
  resource,
  hasPreviousStep,
  onPreviousClick,
  hasNextStep,
  onNextClick,
  emptyStateLabel,
}) => {
  return (
    <React.Fragment>
      <FDStack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <FDSecondaryActionIconButton
          size="lg"
          icon="chevronLeft"
          onClick={onPreviousClick}
          disabled={!hasPreviousStep}
        />
        <FDTitleText value={resource.attr('title')} />
        <FDSecondaryActionIconButton
          size="lg"
          icon="chevronRight"
          onClick={onNextClick}
          disabled={!hasNextStep}
        />
      </FDStack>
      {resource.attr('sections').resources().length() > 0 ? (
        <FDAccordionGroup
          atLeastOneExpanded
          mutualExclusion
        >
          {resource.attr('sections').resources().list().map(el => (
            <FDSimpleAccordion
              expansionID={el.id()}
              title={el.attr('title')}
            >
              <RichTextDisplay content={el.attr('details')} />
            </FDSimpleAccordion>
          ))}
        </FDAccordionGroup>
      ) : (
        <FDEmptyState title={emptyStateLabel} />
      )}
    </React.Fragment>
  );
};

AccordionStepper.defaultProps = {
};

AccordionStepper.propTypes = {
  resource: PropTypes.object.isRequired,
  hasPreviousStep: PropTypes.bool.isRequired,
  onPreviousClick: PropTypes.func.isRequired,
  hasNextStep: PropTypes.bool.isRequired,
  onNextClick: PropTypes.func.isRequired,
  emptyStateLabel: PropTypes.string.isRequired,
};

export default AccordionStepper;
